function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import './SelectTypeahead.css';
import Select, { components as Components } from 'react-select';
import cs from 'classnames';
import { default as withInputContainer } from '../withInputContainer/withInputContainer';
import Dismiss from '../../Icons/Dismiss/Dismiss';
import Caret from '../../Icons/Caret/Caret';
import whitelistProps from '../../utils/whitelistProps';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import compose from '../../utils/compose';
import stripHtml from '../../utils/stripHtml';
import { TextInput } from '../TextInput/TextInput';
import AdditionalIntl from '../../I18n/AdditionalIntl/AdditionalIntl';
import en from './locales/SelectTypeahead.en.json';
import I18n, { formatI18n } from '../../I18n/I18n/I18n';
import { injectIntl } from 'react-intl';
import ThemeContext from '../../ThemeContext';
var whitelist = whitelistProps('onKeyDown', 'screenReaderStatus');
var messages = normalizeLocaleData(en, '@dm/components.select-typeahead');
var IndicatorSeparator = function IndicatorSeparator() {
  return null;
};
var DropdownIndicator = function DropdownIndicator(props) {
  return /*#__PURE__*/React.createElement(Components.DropdownIndicator, props, /*#__PURE__*/React.createElement(Caret, {
    className: "carety"
  }));
};
var ClearIndicator = function ClearIndicator(props) {
  return /*#__PURE__*/React.createElement(Components.ClearIndicator, props, /*#__PURE__*/React.createElement(Dismiss, {
    className: "clear-indicator",
    width: 10,
    height: 10
  }));
};
var customComponents = {
  IndicatorSeparator: IndicatorSeparator,
  DropdownIndicator: DropdownIndicator,
  ClearIndicator: ClearIndicator
};
export var SelectTypeahead = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectTypeahead, _React$Component);
  function SelectTypeahead() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, SelectTypeahead);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SelectTypeahead)).call.apply(_getPrototypeOf2, [this].concat(args)));
    /**
     * There are two types of selects we support and they each
     * have a different format for specifying options
     * Single select: array of objects containing label, value keys
     * Grouped select: array of objects containg label (group label)
     * and options (array of objects that match single select)
     */
    _this.getValue = function (value) {
      if (value !== null && typeof value === 'object' && (value.value || value.value === '')) {
        return value;
      } else {
        var typeaheadValue = null;
        _this.props.options.find(function (option) {
          if (option.value || option.value === '') {
            // Single select
            if (option.value === value) {
              typeaheadValue = option;
            }
            return option.value === value;
          } else {
            // Grouped select
            option.options.find(function (childOption) {
              if (childOption.value === value) {
                typeaheadValue = childOption;
              }
              return childOption.value === value;
            });
            return false;
          }
        });
        return typeaheadValue;
      }
    };
    _this.getValues = function (values) {
      if (Array.isArray(values)) {
        return values.map(function (val) {
          return _this.getValue(val);
        });
      }
      return _this.getValue(values);
    };
    _this.getNoOptionsMessage = function () {
      return /*#__PURE__*/React.createElement(I18n, {
        i18n: _this.props.noOptionsMessage || '@dm/components.select-typeahead.no-options'
      });
    };
    _this.isOptionDisabled = function (option) {
      return !!_this.props.readonly || !!option.disabled;
    };
    _this.getDisabledValue = function (value) {
      var val = _this.getValues(value);
      if (Array.isArray(val)) {
        return val.map(function (_ref) {
          var label = _ref.label;
          return label;
        }).join(', ');
      } else {
        return (val || SelectTypeahead.EMPTY_VALUE).label;
      }
    };
    return _this;
  }
  _createClass(SelectTypeahead, [{
    key: "render",
    // lifecycles
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        auto = _this$props.auto,
        descriptionId = _this$props.descriptionId,
        disabled = _this$props.disabled,
        errorId = _this$props.errorId,
        errorMsg = _this$props.errorMsg,
        id = _this$props.id,
        intl = _this$props.intl,
        _this$props$isLoading = _this$props.isLoading,
        isLoading = _this$props$isLoading === void 0 ? false : _this$props$isLoading,
        label = _this$props.label,
        labelHidden = _this$props.labelHidden,
        labelIcons = _this$props.labelIcons,
        loadingMessage = _this$props.loadingMessage,
        multiple = _this$props.multiple,
        name = _this$props.name,
        onBlur = _this$props.onBlur,
        onChange = _this$props.onChange,
        onFocus = _this$props.onFocus,
        onInputChange = _this$props.onInputChange,
        onMenuClose = _this$props.onMenuClose,
        onMenuOpen = _this$props.onMenuOpen,
        openMenuOnFocus = _this$props.openMenuOnFocus,
        options = _this$props.options,
        placeholder = _this$props.placeholder,
        portal = _this$props.portal,
        readonly = _this$props.readonly,
        required = _this$props.required,
        _this$props$size = _this$props.size,
        size = _this$props$size === void 0 ? 'small' : _this$props$size,
        softFocus = _this$props.softFocus,
        style = _this$props.style,
        supportsEmpty = _this$props.supportsEmpty,
        value = _this$props.value,
        width = _this$props.width,
        attrs = _objectWithoutProperties(_this$props, ["auto", "descriptionId", "disabled", "errorId", "errorMsg", "id", "intl", "isLoading", "label", "labelHidden", "labelIcons", "loadingMessage", "multiple", "name", "onBlur", "onChange", "onFocus", "onInputChange", "onMenuClose", "onMenuOpen", "openMenuOnFocus", "options", "placeholder", "portal", "readonly", "required", "size", "softFocus", "style", "supportsEmpty", "value", "width"]);
      var styl = width ? Object.assign({}, style, {
        width: width
      }) : style;
      var _name = name || "select-".concat(id);
      var opts = supportsEmpty ? SelectTypeahead.EmptyOption.concat(options) : options;
      var styles = SelectTypeahead.getStyles(styl);
      if (disabled) {
        return /*#__PURE__*/React.createElement(TextInput, Object.assign({}, this.props, {
          value: this.getDisabledValue(value)
        }));
      } else {
        return /*#__PURE__*/React.createElement(AdditionalIntl, {
          messages: messages
        }, /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
          return /*#__PURE__*/React.createElement(Select, Object.assign({
            inputId: id,
            "aria-label": stripHtml(formatI18n(intl, label)),
            value: _this2.getValues(value),
            name: _name,
            className: cs("_dm-input _dm-input--".concat(size), "_dm-input--typeahead _dm-input--typeahead--".concat(size), "_dm-input--typeahead--".concat(theme, " _dm-input--typeahead--").concat(theme, "--").concat(size), "auto-typeahead-input", _defineProperty({}, auto, auto)),
            classNamePrefix: "_dm-input--typeahead",
            styles: styles,
            options: opts
            // DOM attrs
            ,
            readOnly: readonly,
            placeholder: placeholder ? intl.formatMessage({
              id: placeholder
            }) : '',
            onBlur: onBlur,
            onChange: onChange,
            onFocus: onFocus,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen
            // react-select options
            ,
            components: customComponents,
            isDisabled: disabled,
            isLoading: isLoading,
            isOptionDisabled: _this2.isOptionDisabled,
            loadingMessage: loadingMessage
            // use pixels for these because otherwise react-select's logic
            // breaks down
            ,
            minMenuHeight: 130,
            maxMenuHeight: 520
            // fix jolts in most cases (except where there's <130px at bottom of screen)
            ,
            menuShouldScrollIntoView: false,
            menuPortalTarget: portal,
            openMenuOnFocus: openMenuOnFocus || softFocus,
            hideSelectedOptions: false,
            noOptionsMessage: _this2.getNoOptionsMessage,
            isMulti: multiple,
            isClearable: true
          }, whitelist(attrs)));
        }));
      }
    }
  }], [{
    key: "getStyles",
    value: function getStyles(style) {
      return Object.assign({}, SelectTypeahead.customStyles, {
        container: function container(base, state) {
          return _objectSpread({}, base, style);
        }
      });
    }
  }]);
  return SelectTypeahead;
}(React.Component);
SelectTypeahead.EMPTY_VALUE = {};
SelectTypeahead.EmptyOption = [{
  value: '',
  label: ''
}];
// custom styles
SelectTypeahead.customStyles = {
  clearIndicator: function clearIndicator(base, state) {
    return _objectSpread({}, base, {
      padding: 0,
      cursor: 'pointer',
      color: '#bdbdbd',
      '&:hover': {
        color: '#bdbdbd'
      }
    });
  },
  control: function control(base, state) {
    var outline = base.outline,
      styles = _objectWithoutProperties(base, ["outline"]);
    return _objectSpread({}, styles, {
      borderRadius: 1,
      minHeight: '2em',
      boxShadow: state.isFocused ? '0 0 0 1px' : 'none',
      backgroundColor: !!state.selectProps.readOnly ? '#f6f6f6' : '#fff',
      borderColor: state.isFocused ? 'hsl(0, 0%, 75%)' : 'hsl(0, 0%, 58%)',
      ':hover': {
        borderColor: 'hsl(0, 0%, 75%)'
      }
    });
  },
  dropdownIndicator: function dropdownIndicator(base, state) {
    return _objectSpread({}, base, {
      padding: 0,
      color: '#000',
      ':hover': {
        color: '#000'
      }
    });
  },
  // ._dm-typeahead__menu
  menu: function menu(base, state) {
    var boxShadow = base.boxShadow,
      styles = _objectWithoutProperties(base, ["boxShadow"]); // We can't style portaled-menu elements in CSS because the elements are at the bottom of the DOM
    // so we'll handle the new Ripple styling here
    var selectProps = state.selectProps;
    var _selectProps$classNam = selectProps.className,
      className = _selectProps$classNam === void 0 ? '' : _selectProps$classNam,
      _selectProps$menuPort = selectProps.menuPortalTarget,
      menuPortalTarget = _selectProps$menuPort === void 0 ? '' : _selectProps$menuPort; // Checking the classname to see if Ripple is enabled seems gross but I'm not sure
    // how we can check the ThemeContext in this static variable
    var isRippleEnabled = className.indexOf('_dm-input--typeahead--ripple') !== -1;
    if (isRippleEnabled && !!menuPortalTarget) {
      return _objectSpread({}, styles, {
        background: 'rgb(255, 255, 255)',
        border: '1px solid #aaa',
        borderRadius: '3px',
        boxShadow: 'rgb(0 0 0 / 20%) 0px 4px 15px 0px',
        fontSize: '0.875rem',
        left: '0px',
        maxWidth: '42em',
        overflow: 'auto',
        transformOrigin: 'center top',
        transition: 'transform 0.25s ease 0s, -webkit-transform 0.25s ease 0s',
        top: '-8px',
        width: '100%'
      });
    }
    return _objectSpread({}, styles, {
      borderRadius: 1,
      margin: 0,
      border: '1px solid #aaa',
      top: !menuPortalTarget && '2em',
      zIndex: 1050
    });
  },
  // _dm-typeahead__menu-list
  menuList: function menuList(base, state) {
    var selectProps = state.selectProps;
    var _selectProps$classNam2 = selectProps.className,
      className = _selectProps$classNam2 === void 0 ? '' : _selectProps$classNam2,
      _selectProps$menuPort2 = selectProps.menuPortalTarget,
      menuPortalTarget = _selectProps$menuPort2 === void 0 ? '' : _selectProps$menuPort2;
    var isRippleEnabled = className.indexOf('_dm-input--typeahead--ripple') !== -1;
    if (isRippleEnabled && !!menuPortalTarget) {
      return _objectSpread({}, base, {
        maxHeight: '12.5rem'
      });
    }
    return _objectSpread({}, base, {
      padding: 0
    });
  },
  noOptionsMessage: function noOptionsMessage(base, state) {
    return _objectSpread({}, base, {
      padding: '4px',
      minHeight: '2em'
    });
  },
  option: function option(base, state) {
    var x = base[':active'],
      styles = _objectWithoutProperties(base, [":active"]);
    var isFocused = state.isFocused,
      isSelected = state.isSelected,
      selectProps = state.selectProps;
    var _selectProps$classNam3 = selectProps.className,
      className = _selectProps$classNam3 === void 0 ? '' : _selectProps$classNam3,
      _selectProps$menuPort3 = selectProps.menuPortalTarget,
      menuPortalTarget = _selectProps$menuPort3 === void 0 ? '' : _selectProps$menuPort3;
    var isRippleEnabled = className.indexOf('_dm-input--typeahead--ripple') !== -1;
    if (isRippleEnabled && !!menuPortalTarget) {
      return _objectSpread({}, styles, {
        backgroundColor: isSelected || isFocused ? 'rgb(244, 244, 244)' : 'rgb(255, 255, 255)',
        borderBottom: '2px solid rgba(46, 27, 70, 0.05)',
        color: '#366dae',
        cursor: 'pointer',
        display: 'block',
        fontFamily: 'inherit',
        fontWeight: isSelected ? '500' : '400',
        listStyle: 'none',
        padding: '1.25rem',
        userSelect: 'none'
      });
    }
    return _objectSpread({}, styles, {
      padding: '4px',
      cursor: 'pointer',
      minHeight: '2em',
      color: '#000',
      fontWeight: state.isSelected ? '700' : '400',
      backgroundColor: state.isDisabled ? '#f6f6f6' : state.isFocused ? 'hsl(0, 0%, 93%)' : 'hsl(0, 0%, 100%)'
    });
  },
  valueContainer: function valueContainer(base, state) {
    return _objectSpread({}, base, {
      padding: '0'
    });
  },
  singleValue: function singleValue(base, state) {
    return _objectSpread({}, base, {
      marginRight: 0,
      paddingRight: 2,
      fontStyle: !!state.selectProps.readOnly ? 'italic' : 'normal'
    });
  }
};
export default compose(injectIntl, withInputContainer({
  type: 'typeahead'
}))(SelectTypeahead);